import React from 'react';
import config from '../../config';
function Footer() {

    return (
        <div className='mx-auto max-w-8xl px-2 sm:px-4 lg:divide-y lg:divide-gray-200 lg:px-8 bg-slate-50 dark:bg-slate-800 absolute bottom-0 w-full'>
            <div className='text-center py-3'>
                <h5 className='text-muted font-semibold text-base'>{config.appName} {config.appVersion} © {(new Date().getFullYear())}</h5>
            </div>
        </div>
    );
}

export default Footer;
